import type { Change } from 'modules/employees/pages/EditInBulk/types'
import type { ColumnNames } from 'modules/employees/pages/EditInBulk/vars'

const isNumericKey = (key: ColumnNames): boolean => !isNaN(Number(key))

const mapColumKeyToChangeProperty = (key: ColumnNames): (keyof Change)[] => {
  // A numeric key means a custom field
  if (isNumericKey(key)) {
    return [key.toString()]
  }

  switch (key) {
    case 'manager':
      return ['manager_id']
    case 'office':
      return ['location_id']
    case 'time_off_supervisor':
      return ['timeoff_manager_id']
    case 'regular_access_starts_on':
      return ['regular_access_starts_on']
    case 'team':
      return ['teams_ids']
    case 'permission_group':
      return ['permission_group_id']
    case 'legal_entity_and_employee_group':
      return ['employee_group_id', 'legal_entity_id']
    default:
      throw Error(`Column key ${key} does not match any possible value`)
  }
}

export default mapColumKeyToChangeProperty
